import { IconButton, Input, InputAdornment, Stack, styled } from '@mui/material';
import React from 'react';
import Iconify from '../../components/Iconify';
import EmojiPicker from '../../components/EmojiPicker';

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: 56,
  marginBottom: 15,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  paddingLeft: theme.spacing(2),
  borderTop: `2px solid ${theme.palette.primary.main}`,
}));

const link = 'https://wa.me/22890283332';

export default function ChatInput({ disabled }) {
  const onClick = () => {
    window.open(link, '_blank');
  };
  return (
    <RootStyle onClick={onClick} sx={{ cursor: 'pointer' }}>
      <Input
        fullWidth
        value=""
        readOnly
        disableUnderline
        placeholder="contact direct"
        startAdornment={
          <InputAdornment position="start">
            <EmojiPicker disabled={disabled} value="" setValue={() => {}} />
          </InputAdornment>
        }
        endAdornment={
          <Stack direction="row" spacing={1} sx={{ flexShrink: 0, mr: 1.5 }}>
            <IconButton size="small">
              <Iconify icon="eva:attach-2-fill" width={22} height={22} />
            </IconButton>
          </Stack>
        }
        sx={{ cursor: 'pointer' }}
      />

      <IconButton color="primary" sx={{ mx: 1 }}>
        <Iconify icon="ic:round-send" width={22} height={22} />
      </IconButton>
    </RootStyle>
  );
}
